var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4B4B4B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "152.3,275.4 133.6,235.7 121.1,235.7 121.1,305.6 134.2,305.6 134.2,265.8 147.6,293.5 157,293.5  170,266 170,305.6 183.1,305.6 183.1,235.7 170.5,235.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "203.1,305.6 248.9,305.6 248.9,293.6 216.2,293.6 216.2,276.4 244.1,276.4 244.1,264.4 216.2,264.4  216.2,247.8 248.9,247.8 248.9,235.7 203.1,235.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "305.8,279.3 277.1,235.7 265.5,235.7 265.5,305.6 278.6,305.6 278.6,262 307.3,305.6 318.9,305.6  318.9,235.7 305.8,235.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M375.9,281.1c0,4.1-1.1,7.3-3.4,9.6c-2.3,2.3-5.2,3.4-9.1,3.4c-3.8,0-6.8-1.1-9-3.4c-2.2-2.3-3.3-5.5-3.3-9.6 v-45.4H338v45.9c0,3.6,0.7,7,1.9,10c1.3,3,3.1,5.6,5.4,7.8c2.2,2.1,5,3.8,8.1,5c3.1,1.2,6.5,1.8,10,1.8c3.5,0,6.9-0.6,10-1.8 c3.1-1.2,5.8-2.9,8.2-5c2.3-2.1,4.1-4.7,5.4-7.8c1.3-3,2-6.4,2-10v-45.9h-13.1L375.9,281.1L375.9,281.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.1,73.1c-6.2,0-11.6-2.5-15.7-6.5c-4-4.1-6.5-9.5-6.5-15.7c0-6.2,2.5-11.6,6.5-15.7 c4.1-4,9.5-6.5,15.7-6.5l346.3,0V0L101.1,0C73,0,50.2,22.8,50.2,50.9v410.2c0,28.1,22.8,50.9,50.9,50.9h360.7V73.1H101.1z  M433.1,483.3h-332c-12.2,0-22.1-9.9-22.2-22.2V96.6c6.7,3.3,14.2,5.1,22.2,5.1h332V483.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableorder);
export default __webpack_public_path__ + "static/media/tableorder.e63c421d346a597008113b263d8bbcd4.svg";
export { ForwardRef as ReactComponent };